import React, { Component } from "react";
import { connect } from "react-redux";

class IconBtn extends Component {
    render() {
        return (
            <div>
                <input id={this.props.ID} className={this.props.class} type="checkbox" onChange={this.props.change} checked={this.props.checked} />
                <label htmlFor={this.props.ID} title={this.props.title}></label>
            </div>
        );
    }
}

export default connect()(IconBtn);
